module.exports = __webpack_public_path__ + "img/wardrobe1.3230805c.jpg";